export const themeTextRed = '#b80f0a';